import { LinkedList } from 'src/utils/link'
import type { RawAction, RawData, Transfer } from 'src/types'

function getLink<T extends Transfer>(link: LinkedList<T>, arr: T[], id: number): LinkedList<T> {
  const arrCache = [...arr]
  const index = arrCache.findIndex(n => n.fromNodeId === id)
  if (index > -1) {
    link.append(arrCache[index])
    const toNodeId = arrCache[index].toNodeId
    // 删除，防止线条循环
    arrCache.splice(index, 1)
    return getLink(link, arrCache, toNodeId)
  }
  return link
}

function handleSortActions(transfers: Transfer[], actions: RawAction[]) {
  //  链表方法
  const arr: RawAction[] = []
  const link = new LinkedList<Transfer>()
  const linkedListNodes = getLink(link, transfers, 0)
  let current = linkedListNodes.head
  while (current) {
    const toId = current.data.toNodeId
    const toNode = actions.find(n => n.properties.id === toId)
    if (toNode && !arr.find(n => n.properties.id === toNode.properties.id)) {
      arr.push(toNode)
    }

    current = current.next
  }
  return arr
}

export function handleRawData(data: RawData) {
  const { start, end, actions = [], transfers } = data
  const hasPosition = !!(
    start?.position
    || end?.position
    || actions.find(n => !!n?.properties?.position)
  )
  if (!hasPosition) {
    // 没有位置信息，需要对 actions 根据 transfers进行排序
    const sortedActions = handleSortActions(transfers, actions)
    return {
      ...data,
      actions: sortedActions,
    }
  }
  return data
}
